import { z } from "zod";

import { monthlyAuditDate } from "@/schemas";

import {
  environmentalChecklistItem,
  environmentalChecklistItemWithTicket,
} from "../../../../schemas";

export const dayEnvChecklistKitchenSchema = z.object({
  auditDate: monthlyAuditDate,
  locationId: z.string().min(1, "Required"),
  reviewerId: z.string().min(1, "Required"),
  kitchenCounter: environmentalChecklistItemWithTicket,
  kitchenFloor: environmentalChecklistItemWithTicket,
  kitchenWall: environmentalChecklistItemWithTicket,
  kitchenStove: environmentalChecklistItem,
  kitchenOven: environmentalChecklistItem,
  kitchenUnderStove: environmentalChecklistItem,
  kitchenStoveHood: environmentalChecklistItemWithTicket,
  kitchenCabinets: environmentalChecklistItemWithTicket,
  kitchenDrawers: environmentalChecklistItemWithTicket,
  kitchenDishes: environmentalChecklistItem,
  kitchenFaucet: environmentalChecklistItemWithTicket,
  kitchenSink: environmentalChecklistItemWithTicket,
  kitchenWindows: environmentalChecklistItemWithTicket,
  kitchenLight: environmentalChecklistItemWithTicket,
  kitchenMicrowave: environmentalChecklistItemWithTicket,
  kitchenDoor: environmentalChecklistItemWithTicket,
  kitchenTrash: environmentalChecklistItemWithTicket,
  kitchenDishwasher: environmentalChecklistItemWithTicket,
  kitchenComment: z.string().optional(),
});
